import { render } from "./MapComponent.vue?vue&type=template&id=56e2d7be"
import script from "./MapComponent.vue?vue&type=script&lang=js"
export * from "./MapComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__